import React from "react";
import NoAuth from "./no-auth";
import { InlineWidget } from "react-calendly";

const ContactSales = () => {
  return (
    <div>
      <InlineWidget
        url="https://meetings-eu1.hubspot.com/marcus-w-christensen"
        styles={{
          height: "95vh",
        }}
      />
    </div>
  );
};


export default <NoAuth title="Contact Sales" component={ContactSales} />;